import cache from "./cachedState";

let state = {
    search: {
        cases: [],
        laws: [],
        digests: [],
        notebooks: []
    },
    recent: {
        cases: [],
        laws: []
    }
};

const cachedStateId = "vuex-history";
var cachedState = cache.load(cachedStateId);
if (cachedState) {
  state = JSON.parse(cachedState);
}
const saveCache = function(state) {
  cache.save(cachedStateId, JSON.stringify(state));
};

let actions = {};

let getters = {
    getSearch(state, type) {
        return state.search[type];
    }
};

let mutations = {
    addSearch(state, data) {
        if(!data.key) {
            return;
        }

        const key = data.key.trim();

        if(key.length == 0) {
            return;
        }

        if(state.search[data.type].includes(key)){
            state.search[data.type].splice(state.search[data.type].indexOf(key), 1);
        }

        state.search[data.type].push(key);
        saveCache(state);
    },
    addRecent(state, data) {
        const temp = state.recent[data.type].filter((i)=>(i.id !== data.data.id));
        state.recent[data.type] = temp;
        state.recent[data.type].push(data.data);
        saveCache(state);
    },
};

export default {
  name: "history",
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};